<template>
  <div data-component-group="filter-forms" data-component="tracking-advertisers" class="tracking-filters">
    <FiltersForm
      :has-filters="hasFilters"
      @filter="onFilter"
      @clear="onClearFilters"
      v-model="selectedCountries"
    >
      <v-text-field
        clearable
        v-model="search"
        type="search"
        label="Search"
        prepend-inner-icon="search"
        hide-details
      />

      <v-select
        v-model="status"
        :items="statuses"
        item-title="name"
        item-value="id"
        label="Status"
        hide-details
        variant="outlined"
        clearable
      />
    </FiltersForm>
  </div>
</template>

<script>
  import stringEscape from 'js-string-escape';
  import FiltersForm from './FiltersBase';
  import { isNonEmptyStr, isNonEmptyArr, isNull, isNum } from '@/utils';

  // TODO: Translate component

  export default {
    components: {
      FiltersForm,
    },
    emits: ['filter', 'clearFilters'],
    data() {
      return {
        search: null,
        selectedCountries: [],
        status: null,
        statuses: [],
      };
    },
    computed: {
      hasFilters() {
        const { search, selectedCountries, status } = this;

        return isNonEmptyStr(search) || isNonEmptyArr(selectedCountries) || isNum(status)
      },
      countries() {
        return this.$store.getters['users/countries'];
      },
    },
    created() {
      this.$store.dispatch('tracking/getFilterStatuses').then((res) => {
        this.statuses = res;
      });
    },
    methods: {
      onFilter() {
        const { search, status } = this;
        const formattedSearch = isNull(search) ? '' : stringEscape(search);

        this.$emit('filter', {
          search: formattedSearch,
          status,
          countries: this.selectedCountries,
        });
      },
      onClearFilters() {
        this.search = null;
        this.status = null;
        this.selectedCountries = [];

        this.$emit('clearFilters');
      },
    },
  };
</script>
